import React, { useCallback, useState } from "react";
import useApiEp from "../../hooks/useApiEp";
import { API_ENDPOINT } from "../../utils/constants";
import {
  Alert,
  Box,
  Button,
  Chip,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import {
  exportToExcel,
  getErrorResponse,
  getHeader,
  roundToMaxDecimals,
  toastError,
} from "../../utils/util";
import { useNavigate } from "react-router-dom";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import CustomCircularP from "../../widgets/CustomCircularP";
import { toast } from "react-toastify";
import axios from "axios";
import SimpleYesNoDialog from "../../widgets/SimpleYesNoDialog";
import PageTitle from "../../widgets/PageTitle";
import SearchIcon from "@mui/icons-material/Search";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { debounce } from "lodash";
import DataTable from "../../widgets/DataTable";
import TitleActionsContainer from "../../widgets/TitleActionsContainer";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import { LoadingButton } from "@mui/lab";
import TemplateStatusChip from "../../widgets/TemplateStatusChip";
import CustomerIdsAutocomplete from "../../widgets/CustomerIdsAutoComplete";
import { GlassButton, GlassButtonLoading } from "../../themes/UiElements";
const AdminRcsTemplates = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [exporting, setExporting] = useState(false);
  const [templateStatus, setTemplateStatus] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [name, setName] = useState("");
  const [sq, setSq] = useState("");
  const navigate = useNavigate();

  const debouncedSearch = useCallback(
    debounce((value) => {
      setSq(value);
    }, 500),
    []
  );
  const handleSearchChange = (value) => {
    setName(value);
    debouncedSearch(value);
  };
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/rcs/get-all-users-templates?page=${page}&limit=${limit}&name=${sq}&customerId=${
      selectedCustomerId ? selectedCustomerId : ""
    }&status=${templateStatus}`
  );
  const handleAction = useCallback((action, id) => {
    switch (action) {
      case "view":
        navigate(`/home/${id}/template-detail`);
        break;
      default:
        console.warn("unknown action", id);
    }
  }, []);
  const handleDataExport = useCallback(async () => {
    try {
      setExporting(true);
      const response = await axios.get(
        `${API_ENDPOINT}/root/get-all-accounts`,
        getHeader()
      );
      exportToExcel(response.data, "accounts_list.xlsx");
    } catch (error) {
      toastError(error);
    } finally {
      setExporting(false);
    }
  }, []);
  const handleStatusSelect = useCallback((e) => {
    setTemplateStatus(e.target.value);
  }, []);
  const handleCustomerIdChange = useCallback((newValue) => {
    setSelectedCustomerId(newValue);
    console.log("Selected customer ID:", newValue);
  }, []);
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  return (
    <Container sx={{ mt: 3 }}>
      <TitleActionsContainer>
        <PageTitle>Templates List ({data?.totalItems || 0})</PageTitle>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          sx={{
            width: { xs: "100%", sm: "auto" },
            mt: { xs: 1, sm: 0 },
          }}
        >
          <TextField
            size="small"
            sx={{ minWidth: 172 }}
            value={name}
            onChange={(e) => handleSearchChange(e.target.value)}
            placeholder="search template"
            InputProps={{ startAdornment: <SearchIcon fontSize="small" /> }}
          />
          <Box minWidth={200}>
            <CustomerIdsAutocomplete
              value={selectedCustomerId}
              onChange={handleCustomerIdChange}
            />
          </Box>
          <FormControl size="small" sx={{ minWidth: 120 }} fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={templateStatus}
              label="Status"
              onChange={handleStatusSelect}
            >
              <MenuItem value={""}>
                <i>All</i>
              </MenuItem>
              <MenuItem value={"pending"}>Pending</MenuItem>
              <MenuItem value={"accepted"}>Accepted</MenuItem>
              <MenuItem value={"rejected"}>Rejected</MenuItem>
            </Select>
          </FormControl>
          <GlassButtonLoading
            loading={exporting}
            sx={{ minWidth: 130 }}
            onClick={handleDataExport}
            variant="contained"
            startIcon={<ImportExportIcon />}
          >
            Export All
          </GlassButtonLoading>
        </Stack>
      </TitleActionsContainer>
      <CustomCircularP show={isLoading} />

      <DataTable
        sx={{ mb: 1 }}
        columns={[
          {
            id: "serial",
            label: "S.No.",
            render: (_v, _row, idx) => (page - 1) * limit + idx + 1,
          },
          { id: "id", label: "Template Id" },
          { id: "name", label: "Name" },
          {
            id: "status",
            label: "Status",
            render: (v) => <TemplateStatusChip status={v} />,
          },
          {
            id: "createdOn",
            label: "Created On",
            render: (v) =>
              new Date(v).toLocaleString("en-IN", {
                dateStyle: "medium",
              }),
          },
        ]}
        actions={["view"]}
        rows={data?.data ?? []}
        page={page}
        itemsPerPage={limit}
        totalPages={data?.totalPages ?? 1}
        onPageChange={setPage}
        onAction={handleAction}
        itemsPerPageOptions={[20, 30, 50, 100]}
        onItemsPerPageChange={(lm) => {
          setLimit(lm);
        }}
        paginationAlign="end"
      />
    </Container>
  );
};

export default AdminRcsTemplates;
